import { trigger, state, style, transition, animate, query, group } from '@angular/animations';

export const ShowHideAnimation = trigger('ShowHideAnimation', [
  state('hide', style({
    height: '0px',
    opacity: '0',
    overflow: 'hidden',
    // display: 'none'
  })),
  state('show', style({
    height: '*',
    opacity: '1',
    // display: 'block'
  })),
  transition('hide => show', animate('1500ms ease-in')),
  transition('show => hide', animate('1500ms ease-out'))

]);
export const slideIn = trigger('slideIn', [
  state('*', style({
    transform: 'translateX(100%)',
  })),
  state('in', style({
    transform: 'translateX(0)',
  })),
  state('out', style({
    transform: 'translateX(-100%)',
  })),
  transition('* => in', animate('600ms ease-in')),
  transition('in => out', animate('600ms ease-in'))
]);



export const SlideLeftRight = trigger('SlideLeftRight', [
  state('*', style({
    transform: 'translateX(100%)',
  })),
  state('left', style({ transform: 'translateX(100%)' })),
  state('right', style({ transform: 'translateX(0%)' })),
  transition('* => *', animate(300))
]);


